import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Instagram, Linkedin } from "lucide-react";
import JoinNowButton from "@/components/landing/JoinNowButton";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

interface SiteNavProps {
  transparent?: boolean;
}

const SiteNav = ({ transparent = false }: SiteNavProps) => {
  const [open, setOpen] = useState(false);

  return (
    <nav className={`${transparent ? 'absolute top-0 left-0 right-0 bg-transparent' : 'sticky top-0 bg-background/80 backdrop-blur-md border-b'} z-50 container flex items-center justify-between py-6`}>
      <div className="flex items-center gap-4">
        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Open menu">
                <Menu className={`h-6 w-6 ${transparent ? 'text-white' : ''}`} />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-80">
              <div className="flex flex-col justify-between h-full pt-8 pb-6 pl-6">
                <div className="space-y-8">
                  <a 
                    href="https://outfitalliance.com/" 
                    className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                    onClick={() => setOpen(false)}
                  >
                    Home
                  </a>
                  
                  <div className="space-y-3">
                    <Link 
                      to="/" 
                      className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                      onClick={() => setOpen(false)}
                    >
                      Creators
                    </Link>
                    <Button
                      size="sm"
                      variant="hero"
                      className="w-full"
                      onClick={() => {
                        setOpen(false);
                        window.location.href = '/creatorsignup';
                      }}
                    >
                      Creator Join Now
                    </Button>
                  </div>
                  
                  <div className="space-y-3">
                    <Link 
                      to="/brands" 
                      className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                      onClick={() => setOpen(false)}
                    >
                      Brands
                    </Link>
                    <Button
                      size="sm"
                      variant="hero"
                      className="w-full"
                      onClick={() => {
                        setOpen(false);
                        window.location.href = '/brandsignup';
                      }}
                    >
                      Brands Join Now
                    </Button>
                  </div>

                  <div>
                    <Link 
                      to="/faqs" 
                      className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                      onClick={() => setOpen(false)}
                    >
                      Frequently Asked Questions
                    </Link>
                  </div>
                </div>

                <div className="border-t pt-6 space-y-4">
                  <Link 
                    to="/legal" 
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors block"
                    onClick={() => setOpen(false)}
                  >
                    Legal
                  </Link>
                  <div className="flex items-center gap-4">
                    <a
                      href="https://www.instagram.com/trycloutfit/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram: @trycloutfit"
                      className="text-muted-foreground hover:text-foreground transition"
                    >
                      <Instagram size={24} />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/cloutfit-ai"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn: Cloutfit.ai"
                      className="text-muted-foreground hover:text-foreground transition"
                    >
                      <Linkedin size={24} />
                    </a>
                  </div>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
        
        <Link
          to="/"
          className={`hidden md:flex items-center gap-2 font-roxborough rounded-full bg-foreground text-background px-3 py-1.5 font-medium tracking-tight shadow-elegant hover:opacity-90 transition`}
          aria-label="Outfit Alliance by Cloutfit.ai home"
        >
          <img src="/assets/logo.avif" alt="" className="h-7 w-auto" />
          Outfit Alliance by Cloutfit.ai
        </Link>
      </div>
      
      <div className="hidden md:flex items-center gap-8">
        <div className="flex items-center gap-6 text-sm">
          <a 
            href="https://outfitalliance.com/" 
            className={`font-medium transition-colors ${transparent ? 'text-white hover:text-white/80' : 'hover:text-primary'}`}
          >
            Home
          </a>
          <Link 
            to="/" 
            className={`font-medium transition-colors ${transparent ? 'text-white hover:text-white/80' : 'hover:text-primary'}`}
          >
            Creators
          </Link>
          <Link 
            to="/brands" 
            className={`font-medium transition-colors ${transparent ? 'text-white hover:text-white/80' : 'hover:text-primary'}`}
          >
            Brands
          </Link>
        </div>
        <JoinNowButton />
      </div>
      
      <div className="md:hidden">
        <JoinNowButton variant="text" />
      </div>
    </nav>
  );
};

export default SiteNav;
